import { DestroyRef, Directive, ElementRef, inject, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ITooltipDirective } from "@front/m19-ui";
import { debounceTime, fromEvent, startWith } from "rxjs";

@Directive({
  selector: "[tooltipTruncated]",
  standalone: true,
  // TODO: this is a workaround to be able to inject the ITooltipDirective, we should find a better way to do this in the future (https://github.com/angular/angular/issues/50510)
  hostDirectives: [
    {
      directive: ITooltipDirective,
    },
  ],
})
export class TooltipTruncatedDirective implements OnInit {
  private elementRef = inject(ElementRef);
  private tooltipDirective = inject(ITooltipDirective);

  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.tooltipDirective.setMessage(undefined);
    fromEvent(window, "resize")
      .pipe(startWith(null), debounceTime(500), takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.checkTruncate());
  }

  private checkTruncate(): void {
    const element = this.elementRef.nativeElement;
    const isTruncated = element.offsetWidth < element.scrollWidth;
    if (isTruncated) {
      this.tooltipDirective.setMessage(element.textContent);
    } else {
      this.tooltipDirective.setMessage(undefined);
    }
  }
}
